import React from 'react';
import ToolLayout from '../../components/ToolLayout';
import UnitConverter from '../../components/UnitConverter';

const UnitConvert: React.FC = () => (
  <ToolLayout
    title="Unit Converter - Length, Weight, Temperature | AllTools"
    description="Convert between units of length, weight, temperature, and volume. Free online unit converter."
    canonicalPath="/unit-converter"
  >
    <UnitConverter />
  </ToolLayout>
);

export default UnitConvert;
